import { render, staticRenderFns } from "./PainelSalasTable.vue?vue&type=template&id=4459daa7&scoped=true"
import script from "./PainelSalasTable.vue?vue&type=script&lang=js"
export * from "./PainelSalasTable.vue?vue&type=script&lang=js"
import style0 from "./PainelSalasTable.vue?vue&type=style&index=0&id=4459daa7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4459daa7",
  null
  
)

export default component.exports